var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("section-title", { attrs: { icon: "mdi-file-table-outline" } }, [
        _vm._v("INFORMES DE MANTENIMIENTO DEL ÚLTIMO AÑO")
      ]),
      _c("ListView", {
        attrs: {
          data: _vm.bills,
          "is-loading": _vm.loading,
          "repository-function": _vm.repositoryFunction,
          type: "inform"
        },
        on: {
          "update:isLoading": function($event) {
            _vm.loading = $event
          },
          "update:is-loading": function($event) {
            _vm.loading = $event
          }
        }
      }),
      (!_vm.bills || !_vm.bills.length) && !_vm.loading
        ? _c(
            "v-container",
            {
              staticClass: "empty-state",
              attrs: {
                "pa-0": "",
                "ma-0": "",
                fluid: "",
                "justify-center": "",
                "fill-height": ""
              }
            },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/empty-state-reports.png"),
                    alt: "No hay informes para listar"
                  }
                }),
                _c("p", [_vm._v("No hay informes para listar")])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }